import QueryString from "query-string";

import { RouterEnum } from "./routers";

const STORAGE_KEY = "tatraPremiumOauthRedirectParams";
const OAUTH_PARAMS = ["code", "state"];

// Keycloak rejects redirect_uri containing OAuth params (code, state), so they are
// moved from the query to sessionStorage before keycloak init/login builds the redirect_uri.
export const stashOauthRedirectParams = (history) => {
  const { pathname, search, hash } = history.location;

  if (!pathname.startsWith(RouterEnum.TatraPremiumOatuhRedirect.Path)) return;

  const queryData = QueryString.parse(search);

  if (!OAUTH_PARAMS.some((p) => queryData[p] != null)) return;

  const params = {};
  OAUTH_PARAMS.forEach((p) => {
    params[p] = queryData[p] ?? null;
    delete queryData[p];
  });

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));

  const rest = QueryString.stringify(queryData);
  history.replace({ pathname, search: rest ? `?${rest}` : "", hash });
};

export const getOauthRedirectParams = () => {
  try {
    const params = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (params) return params;
  } catch (e) {}

  return { code: null, state: null };
};

export const clearOauthRedirectParams = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
